"use client";

import Image from "next/image";
import { usePathname } from "next/navigation";
import { UserProfile } from "src/api/users/types";
import { ThemeToggle } from "src/components/ThemeToggle";
import { ClientPopover } from "./ClientPopover";

function extractInitials(name: string): string {
  if (!name) return "";
  const [surName, lastName] = name.split(" ");
  return (surName.slice(0, 1) + (lastName || "").slice(0, 1)).toUpperCase();
}

function getBuildVersion() {
  const commitSha = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA?.trim();

  if (!commitSha) {
    return {
      label: "local",
      title: "Local development build",
    };
  }

  return {
    label: commitSha.slice(0, 7),
    title: commitSha,
  };
}

export function UserAvatar({ user }: Readonly<{ user?: UserProfile }>) {
  const pathname = usePathname();
  if (!user) return null;

  const buildVersion = getBuildVersion();
  const imageUrl = "https://ui-avatars.com/api/?format=png&name=" + extractInitials(user.name);
  const button = (
    <Image
      className="w-9 h-9 rounded-full object-cover"
      width={24}
      height={24}
      src={imageUrl}
      alt={user.name}
    />
  );
  const panel = (
    <div className="py-1">
      <p className="block px-4 py-2 text-base text-gray-500 dark:text-gray-400">{user.email}</p>
      <hr className="border-gray-200 dark:border-gray-700" />
      <ThemeToggle />
      <hr className="border-gray-200 dark:border-gray-700" />
      <a
        href="https://forms.clickup.com/f/a23k9-1211/YSJBBEX6VOAJYLGPD1"
        target="_blank"
        rel="noreferrer"
        className="block px-4 py-2 text-base text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
      >
        Feedback
      </a>
      <a
        href={`/logout?returnUrl=${pathname}`}
        className="block px-4 py-2 text-base text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
      >
        Logout
      </a>
      <hr className="border-gray-200 dark:border-gray-700" />
      <div
        className="px-4 py-2.5 text-xs text-gray-500 dark:text-gray-400"
        title={buildVersion.title}
      >
        <span className="font-medium text-gray-600 dark:text-gray-300">Build</span>{" "}
        <span className="font-mono">{buildVersion.label}</span>
      </div>
    </div>
  );
  return <ClientPopover button={button} panel={panel} />;
}
